import React from 'react';
import MatchTable from '../Common/MatchTable';
import { Remark } from '../Common/MatchBase';

const INPLAY = () => {
    
    return (
        <section className='HAD INPLAY'>
            <MatchTable betType='HAD' etBetType='EHA' />
            <Remark />
        </section>
    )
}
export default INPLAY;